import { apiClient } from '@/lib/apiClient';
import type { ApiResponse, User, UserUpdate } from "dico-types";

// ============================================================================
// USER API FUNCTIONS
// ============================================================================

/**
 * Get the current authenticated user's profile.
 * @param signal - Optional abort signal.
 */
const getMe = (signal?: AbortSignal) => {
  return apiClient.get<ApiResponse<User>>('/api/me', { signal });
};

/**
 * Update the current user's profile.
 * @param data - Fields to update.
 * @param signal - Optional abort signal.
 */
const updateMe = (data: UserUpdate, signal?: AbortSignal) => {
  return apiClient.put<ApiResponse<User>>('/api/me', data, { signal });
};

/**
 * Soft-delete the current user account.
 * @param signal - Optional abort signal.
 */
const deleteMe = (signal?: AbortSignal) => {
  return apiClient.delete<ApiResponse>('/api/me', { signal });
};

export const userApi = {
  getMe,
  updateMe,
  deleteMe
};

export { getMe, updateMe, deleteMe };
